import axios from 'axios';
import { LEADS_ENDPOINT } from 'cfgCommon/endpoints'

export async function getOpportunityData(leadId, module, historyFiltersDays = null) {
    // TODO Separar en distintos endpoints
    try {
        let queryParams = historyFiltersDays ? `&historyFiltersDays=${historyFiltersDays}` : ''
        const data = await axios.get(`${LEADS_ENDPOINT}/getOpportunityData/${leadId}?module=${module}${queryParams}`)
        return data.data;
    } catch (error) {
        throw new Error(error)
    }
}